export default __webpack_public_path__ + "static/media/tipTick.4b4de2dd.svg";